import { FC } from 'react';
import { UnavailabilityView } from '../../unavailabilityView/index';
import { useGetEquipmentQuery } from '../../../shared/redux/rental';
import { LoadingSkeleton } from './loadingSkeleton';

export const UnavailabilityTab: FC<{id: number | string}> = ({ id }) => {
  const { data: equipment, isLoading } = useGetEquipmentQuery(id);

  if (!equipment || isLoading) return <LoadingSkeleton />;

  return (
    <div>
      <UnavailabilityView
        id={equipment.internalNumber}
        currentDate={new Date()}
      />
    </div>
  );
};
